/* eslint-disable react/jsx-props-no-spreading */
import { InputLabel, makeStyles } from "@material-ui/core";
import { useField } from "formik";
import PropTypes from "prop-types";
import React from "react";
import ImageUploader from "../ImageUploader";

const useStyles = makeStyles(theme => ({
  root: {
    flexDirection: "column"
  },
  label: {
    marginBottom: theme.spacing(2),
    fontSize: "0.8rem"
  }
}));

const ImageUploaderField = ({ name, label, ...other }) => {
  const [field, meta, { setValue }] = useField(name);
  const isInError = Boolean(meta.touched) && Boolean(meta.error);
  const classes = useStyles();
  return (
    <div className="root">
      <InputLabel className={classes.label}>{label}</InputLabel>
      <ImageUploader
        imageUrl={field.value}
        margin="normal"
        error={isInError}
        helperText={isInError && meta.error}
        onFileUpload={({ file }) => {
          setValue(file);
        }}
        {...field}
        {...other}
      />
    </div>
  );
};

ImageUploaderField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired
};

export default ImageUploaderField;
